import { ViewerItem } from 'presentations/api/schema/user';
import { setEvent } from 'presentations/views/helpers/analytics';
import { SyntheticEvent, useState } from 'react';
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

interface Props {
  viewer: ViewerItem;
  onSubmitMessage: (content: string) => void;
}

export const useHomeView = (props: Props) => {
  const t = translateInComponent([translations]);
  const [content, setContent] = useState<string | null>(null);
  const [messages, setMessages] = useState<
    { role: 'system' | 'user'; content: string }[]
  >([
    {
      role: 'system',
      content: t('Description'),
    },
  ]);

  const onChangeMessage = (e: SyntheticEvent<HTMLInputElement>) => {
    setContent(e.currentTarget.value);
  };

  const onSubmitMessage = async (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!content) return;
    setContent('');
    setEvent('submit chat assistant add message', {
      view: 'home',
    });
    props.onSubmitMessage(content);
  };

  return {
    state: {
      content,
      isNoContent: !Boolean(content),
      messages,
    },
    actions: {
      onChangeMessage,
      onSubmitMessage,
    },
  };
};
